import {ReportType} from '@/types/reports/Report'
import ExportsDialog from '@/exports/ExportsDialog.vue'
import useDynamicComponentLoader from '@/dynamic-component-loader/dynamicComponent.service'
import {post} from '@/services/infrastructure/api.service'
import {download} from '@/services/infrastructure/storage.service'
import {ReportMeta} from '@/types/ReportMeta'
import {notifyError} from '@/services/infrastructure/notification.service'

const {loadComponent} = useDynamicComponentLoader()

const generateBaseUrl = '/reports/generate'

export type ExportType = 'PDF' | 'Excel'
export type ExportOption = {
    type: ExportType
    icon: string
    download: boolean
    email: boolean
    disabled?: boolean
}

export type ExportQuery = {
    fromDate: string,
    toDate: string,
    project?: string,
    department?: string
}

export const defaultExportOptions: ExportOption[] = [
    {type: 'PDF', icon: 'i-ph-file-pdf', download: true, email: false},
    // {type: 'Excel', icon: 'i-ph-file-xls', download: false, email: false, disabled: true}
]

export const showExportsDialog = (reportType: ReportType, exportQuery: ExportQuery) => {
    loadComponent(ExportsDialog, {
        reportType,
        exportQuery
    })
}

export const exportReport = async (reportType: ReportType, exportQuery: ExportQuery, exportOptions: ExportOption[] = [], emailRecipients: String[] = []) => {
    try {
        const response = await post(generateBaseUrl, exportOptions.filter(o => o.download), {}, {
            type: reportType.toUpperCase(),
            ...exportQuery,
            emailRecipients
        })
        response.forEach((documentMeta: ReportMeta) => download(documentMeta))
    } catch (e: any) {
        console.error('Error exporting report:', e)
        notifyError({ title: 'Feilet', description: { descriptionMessage: 'Kunne ikke eksportere rapport', error: e }})
        throw e
    }
}

